import KpiCard from '../../components/admin/KpiCard';
import useAdminData from './useAdminData';
import { fetchResponseTimes } from '../../services/adminStatsService';

export default function AdminResponseTimes() {
  const { data, loading, error } = useAdminData(fetchResponseTimes);

  if (loading) return <div className="text-gray-500">Loading…</div>;
  if (error) return <div className="text-red-600">{error}</div>;
  if (!data) return null;

  const { withinSLA = {} } = data;

  return (
    <div className="space-y-4">
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
        <KpiCard label="Average (min)" value={data.avgFirstResponseMin} icon="⏱️" />
        <KpiCard label="p50 (min)" value={data.p50} icon="📐" />
        <KpiCard label="p90 (min)" value={data.p90} icon="📐" />
        <KpiCard label="p95 (min)" value={data.p95} icon="📐" />
      </div>
      <div className="bg-white rounded-lg border border-gray-200 p-4">
        <h3 className="text-sm font-semibold text-gray-700 mb-3">Within SLA</h3>
        <div className="grid grid-cols-3 gap-3">
          <SlaRow label="< 5 min" value={withinSLA.m5} />
          <SlaRow label="< 15 min" value={withinSLA.m15} />
          <SlaRow label="< 60 min" value={withinSLA.m60} />
        </div>
        <div className="text-xs text-gray-500 mt-2">{data.total} conversations analyzed.</div>
      </div>
    </div>
  );
}

function SlaRow({ label, value }) {
  const pct = ((value || 0) * 100).toFixed(1);
  return (
    <div>
      <div className="text-xs text-gray-500 mb-1">{label}</div>
      <div className="h-3 bg-gray-100 rounded overflow-hidden">
        <div style={{ width: `${pct}%`, background: '#059669' }} className="h-full" />
      </div>
      <div className="text-sm mt-1 font-medium text-gray-800">{pct}%</div>
    </div>
  );
}
